<script>
  //import { onMount } from "svelte";
  import { flip } from "svelte/animate";

  export let question = "";
  export let alts = [{ text: 1 }, { text: 2 }, { text: 3 }, { text: 4 }];
  export let altUpdated = () => {};

  export let answered;

  function select(alt, i) {
    alts.forEach((a) => {
      a.selected = false;
    });
    alts[i].selected = true;
    altUpdated();
  }
 let i = 1;
    alts.forEach((alt) => {
      alt.id = i++;
    });

    shuffle(alts);
    alts = alts;


  answered.subscribe((r) => {
     
      if (r.wrong) {
        alts.forEach((a) => {
          a.selected = false;
        });
        shuffle(alts);
        alts = alts;
      }
    });

   


  // onMount(() => {
  
  // });

  // function wrongAnswer() {
  //   // console.log("Felell!")
  // }

  function shuffle(array) {
    let currentIndex = array.length,
      randomIndex;

    // While there remain elements to shuffle.
    while (currentIndex != 0) {
      // Pick a remaining element.
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex],
        array[currentIndex],
      ];
    }

    return array;
  }
</script>

<!-- <button on:click={()=>{alts=shuffle(alts)}}>shuffle</button> -->
<div class="question">
  <div class="questiontext">
    {question}
  </div>

  <div class="alts">
    {#each alts as alt, i (alt.text)}
      <div
        class="alt"
        class:alt-selected={alt.selected}
        on:click={() => select(alt, i)}
        animate:flip
      >
        {alt.text}
      </div>
    {/each}
  </div>
</div>

<style>
  .question {
    font-size: x-large;
    color: var(--text-dark);
    background-color: var(--bg);
    padding: 5px;
  }
  .alts {
    display: flex;
    justify-content: space-evenly;
    flex-grow: 1;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    color: var(--text-dark);
    gap: 10px;
  }
  .alt {
    /* outline: 1px solid black; */

    width: 0px;
    flex-grow: 1;
    text-align: center;

    transition: 500ms;
    cursor: pointer;
    text-shadow: none;
    box-shadow: var(--shadow);
    border-radius: 5px;
    background-color: var(--light-color);
    box-shadow: var(--shadow), var(--shadow-light);
    user-select: none;
    color: var(--text-dark);
    padding: 5px;
    -webkit-tap-highlight-color: transparent;

    background-color: #eeeeee;
  }

  .alt-selected {
    transition: 25ms linear;
    /* outline: 1px solid white;     */
    background-color: var(--text-dark);
    color: var(--text-clr-light);
    /* transform: scale(1.5); */
    /* font-size: xx-large; */
  }

  .alt:active {
    transition: 25ms linear;

    transform: translateY(5px);
  }
</style>
